export default {
    graphqlServer: 'localhost:4000',
    // graphqlServer: 'graphql.appotime.com',
    sentry: {
        sampleRate: 0, // send 0% of events
    },
    tawk: {
        enabled: false,
    },
    stripe: {
        public:
            'pk_test_51OHmqTClrAD238487j892FQ6eH1w2aJUjLmJOiAmrdr8VlhjUsRBqcZkiTx4pdqgYqizNypgkaQd71uB2lE3NZg600sF36EV4z',
    },
};
